import Alert from './alert.vue';
export default Alert;


// WEBPACK FOOTER //
// ./src/Alert/index.js